import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CreateNewTemperature } from "./setupRequestBody";
import { addonsInitial, categoryInitial, sizeInitial, temperatureInitial } from "./setupInitialState";
import { AddonsSlice, CategorySlice, SetupTypeShow, SetupTypeUpdate, SizeSlice, TemperatureSlice } from "./setupInterface";
import { RootState } from "../../app/store";

type SetupAction =
    | { type: 'show'; value: SetupTypeShow; }
    | { type: 'update'; value: SetupTypeUpdate; };


interface initialStateSetup {
    temperature: TemperatureSlice;
    addons: AddonsSlice;
    category: CategorySlice;
    sizes: SizeSlice;
    setupTypeShow: SetupTypeShow;
    setupTypeUpdate: SetupTypeUpdate;
    setUpTypeId: null | number;
    isShowOption: boolean;
}

const initialState: initialStateSetup = {
    temperature: temperatureInitial,
    addons: addonsInitial,
    category: categoryInitial,
    sizes: sizeInitial,
    setupTypeShow: null,
    setupTypeUpdate: null,
    setUpTypeId: null,
    isShowOption: false,
}

const setupSlice = createSlice({
    name: 'setup',
    initialState,
    reducers: {
        setSetup: (state, action: PayloadAction<SetupAction>) => {
            const { type, value } = action.payload;

            if (type === 'show') {
                state.setupTypeShow = value;
            }

            if (type === 'update') {
                state.setupTypeUpdate = value;
            }
        },
        setSetupTypeId: ( state, action: PayloadAction<number | null>) => {
            state.setUpTypeId = action.payload;
        },

        setTemperature: ( state, action: PayloadAction<Partial<TemperatureSlice>>) => {
            state.temperature = {
                ...state.temperature,
                ...action.payload,
            };
        },
        setPopulateTemperature: (state, action: PayloadAction<TemperatureSlice>) => {
            state.temperature = action.payload;
        },

        setAddons: ( state, action: PayloadAction<Partial<AddonsSlice>>) => {
            state.addons = {
                ...state.addons,
                ...action.payload,
            };
        },
        setPopulateAddons: (state, action: PayloadAction<AddonsSlice>) => {
            state.addons = action.payload;
        },

        setCategory: ( state, action: PayloadAction<Partial<CategorySlice>>) => {
            state.category = {
                ...state.category,
                ...action.payload,
            };
        },
        setPopulateCategory: (state, action: PayloadAction<CategorySlice>) => {
            state.category = action.payload;
        },

        setSizes: ( state, action: PayloadAction<Partial<SizeSlice>>) => {
            state.sizes = {
                ...state.sizes,
                ...action.payload,
            };
        },
        setPopulateSizes: (state, action: PayloadAction<SizeSlice>) => {
            state.sizes = action.payload;
        },

        setIsShowOption: (state, action: PayloadAction<boolean>) => {
            state.isShowOption = action.payload;
        },
        clearSetupType: ( state,  action: PayloadAction<{ setupType?: boolean; temperature?: boolean; setupTypeId?: boolean; setupTypeUpdate?: boolean, addons?: boolean, category?: boolean, sizes?: boolean }> ) => {
            if (action.payload.setupType) {
                state.setupTypeShow = null;
            }

            if (action.payload.temperature) {
                state.temperature = temperatureInitial;
            }
            if (action.payload.addons) {
                state.addons = addonsInitial;
            }
            if (action.payload.category) {
                state.category = categoryInitial;
            }
            if (action.payload.sizes) {
                state.sizes = sizeInitial;
            }

            if (action.payload.setupTypeId) {
                state.setUpTypeId = null;
            }

            if (action.payload.setupTypeUpdate) {
                state.setupTypeUpdate = null;
            }
        },
    }
})

export const {
    setSetupTypeId,
    setSetup,

    setTemperature,
    setPopulateTemperature,

    setAddons,
    setPopulateAddons,

    setCategory,
    setPopulateCategory,

    setSizes,
    setPopulateSizes,

    setIsShowOption,

    clearSetupType, // dynamic clear
} = setupSlice.actions

export default setupSlice.reducer;

export const selectTemperature = (state: RootState) => state.setup.temperature;
export const selectAddons = (state: RootState) => state.setup.addons;
export const selectCategory = (state: RootState) => state.setup.category;
export const selectSizes = (state: RootState) => state.setup.sizes;

export const selectSetupType = (state: RootState) => state.setup.setupTypeShow;
export const selectSetupTypeUpdate = (state: RootState) => state.setup.setupTypeUpdate;
export const selectSetupUpdateId = (state: RootState) => state.setup.setUpTypeId;
export const selectIsShowOption = (state: RootState) => state.setup.isShowOption;